import { RootState } from 'src/store/store';
import { connect } from 'react-redux';
import JackpotPage from './JackpotPage';

const mapStateToProps = (state: RootState) => ({
    accessibleTools: state.Init.initData.associateDetails.accessibleTools,
});

export default connect(mapStateToProps)(JackpotPage);
